import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { TrendingUp, Layers, Building2, Target } from "lucide-react";
import {
  SA_PRIMARY,
  SA_SECONDARY,
  saReadableText,
  saGradientLine,
  saDarkCardBase,
  saCardBgHover,
  onDarkCardEnter,
  onDarkCardLeave,
} from "./saSectionTokens";

const STATS = [
  {
    icon: TrendingUp,
    headline: "$1 Trillion+",
    sub: "Infrastructure, real estate and giga-project investments planned across Vision 2030.",
    color: SA_PRIMARY,
  },
  {
    icon: Layers,
    headline: "14+ Giga Projects",
    sub: "Driving the future of smart cities, tourism, housing, logistics and industrial development.",
    color: SA_SECONDARY,
  },
  {
    icon: Building2,
    headline: "8 Saudi Cities",
    sub: "Ranked in the IMD Smart City Index 2026, reflecting the Kingdom's rapid digital urban transformation.",
    color: SA_PRIMARY,
  },
  {
    icon: Target,
    headline: "2030 Vision",
    sub: "Accelerating AI, Digital Twins, IoT, BIM and smart infrastructure across the public and private sectors.",
    color: SA_SECONDARY,
  },
];

function SAStatisticsSection() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;

  return (
    <section className="section py-5" style={{ background: "transparent", position: "relative", zIndex: 1 }}>
      <Container>
        <Row className="justify-content-center mb-5">
          <Col className="text-center">
            <h2
              className="mb-0"
              style={{
                fontSize: size ? "2.25rem" : "1.7rem",
                fontWeight: 700,
                letterSpacing: "0.05em",
                lineHeight: 1.2,
                textTransform: "uppercase",
                color: SA_PRIMARY,
                ...saReadableText,
              }}
            >
              Kingdom at a Glance
            </h2>
            <div
              style={{
                width: "110px",
                height: "4px",
                borderRadius: "2px",
                margin: "1rem auto 0",
                ...saGradientLine,
              }}
            />
          </Col>
        </Row>
        <Row>
          {STATS.map((item, index) => {
            const Icon = item.icon;
            return (
              <Col key={index} lg={6} className="mb-4">
                <Card
                  style={{
                    ...saDarkCardBase,
                    borderRadius: "20px",
                    padding: size ? "1.75rem" : "1.4rem",
                    height: "100%",
                    transition: "all 0.35s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => onDarkCardEnter(e, item.color)}
                  onMouseLeave={onDarkCardLeave}
                >
                  <div className="d-flex align-items-start">
                    <div
                      style={{
                        width: size ? 56 : 50,
                        height: size ? 56 : 50,
                        minWidth: size ? 56 : 50,
                        borderRadius: "16px",
                        background: `linear-gradient(145deg, ${item.color}30, ${item.color}12)`,
                        border: `2px solid ${item.color}55`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "1.1rem",
                      }}
                    >
                      <Icon size={size ? 28 : 24} strokeWidth={2} style={{ color: item.color }} />
                    </div>
                    <div>
                      <h3
                        className="text-white mb-2"
                        style={{
                          fontSize: size ? "1.45rem" : "1.2rem",
                          fontWeight: 800,
                          letterSpacing: "0.02em",
                          lineHeight: 1.25,
                          textTransform: "uppercase",
                          ...saReadableText,
                        }}
                      >
                        {item.headline}
                      </h3>
                      <p
                        className="text-white mb-0"
                        style={{
                          fontSize: size ? "1rem" : "0.92rem",
                          lineHeight: 1.65,
                          opacity: 0.95,
                          fontWeight: 400,
                          ...saReadableText,
                        }}
                      >
                        {item.sub}
                      </p>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
        <Row className="mt-2">
          <Col lg={12}>
            <Card
              style={{
                ...saDarkCardBase,
                border: `1px solid ${SA_SECONDARY}40`,
                borderRadius: "16px",
                padding: size ? "1.5rem" : "1.25rem",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = saCardBgHover;
              }}
              onMouseLeave={onDarkCardLeave}
            >
              <p
                className="mb-0 text-center"
                style={{
                  fontSize: size ? "1.08rem" : "1rem",
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: SA_SECONDARY,
                  ...saReadableText,
                }}
              >
                As projects become larger, more interconnected and increasingly data-driven, digital
                twins are emerging as the foundation for predictive operations, intelligent
                decision-making, sustainability and lifecycle asset management.
              </p>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SAStatisticsSection;
